const BASE = "https://fohamu.com/assets/";

// Full ICDH / school-life photo set imported from fohamu.com
export const COMMUNITY_PHOTOS = [
  "icdh-eaa6f9f997a30b488cab5e035e4aa8eb254c9b2f3c42a2119c3a67d54d212bb3.jpg",
  "jean_teaching-f6198a5d3699513418c8ab3fac730077d2677ae7614f0e9d763580a01cfdd8a9.jpg",
  "lady_teacher2-b5d9b30051c874eec9b353b95d4f89d8574aa95c0a57286fb50965f21b70f6e5.jpg",
  "assembly2-f7a81ae29e79d9e161c4d9a0da07869ce879c3e1fe990ec6ee3e8e3d26bd585d.jpg",
  "auditorium-ea96d32f82cb6226d7c443dedccecbe9caf1a6ba7e0f1157fcc909e4f4713cfa.jpg",
  "class2-778c0457c7159d510b30e3d1f644fb6e85039cae715611c76ed82727e7382246.jpg",
  "class-04b087fbac51b38e2ae0c7d4b88eaa2a0e9880fa3b19ce8c18674914a9752232.jpg",
  "class_session-ffb41e650e5d670c2632e38ed9e462cf9a80030e12e250af3d9cbf5a83eb6ba5.jpg",
  "students_chairs-8bb5117addaa6f13693cbfe6020fcac2f4e688b409c88f7d7fcd5dc8e6cd99e1.jpg",
  "students_chairs2-cfb552788c36ed4db33b55d522690aad3048d47b6ec953ee5f67362953bae2e3.jpg",
  "laptop_class-37d36a10c8464ac62105f550562e0ce3a02b12c9d30545eb02d15e0193ac5e0e.jpg",
  "herbert_teaching-cefca458e02b79c98e1f7cad7062730cd5ca6efbdeb161b0041a8ad6560ff648.jpg",
  "students_chairs3-44f93052070b18ef1452cef271078fdcc46644dc4c690485a5b72aab0ea40023.jpg",
  "kids_laptop-2fd9f38bb94c5e6f55e66233b72322c0e71589532506c135a7b1fde6acba0637.jpg",
  "courtyard-383b721fcd33454dab185f4b31a25869ea95761fa334804176f5f77cd5647c96.jpg",
  "courtyard_group-c57d0832fb6bf3b215b83e34c4599b5f33dbd1f83b5fa0d607c1b39fac8239f9.jpg",
  "prof_dev-4477e06400d5e4a1d6e34f47a40bbbc917aae1ca64b5b42ae4637f6539aed82a.jpg",
  "adult_learning-1c647c60127e12b2e94919bb63b2f7178dfce82b01d399f849766cd55a27f3a7.jpg",
  "prof_dev2-45c7076747f55d4b29459f20b385041a9a80e5216bbfec9cae3f8089b588168f.jpg",
  "herbert_jean_students-1e8c4d433f1328c20c548fd1c1336b6ddcd7af1689a81dbe696504c392f9b5ee.jpg",
  "bookbag_student-cd82b73047e70180729d37f9272914186ffdfda97d76ba14de63c0229ce08cb3.jpg",
  "field_trip2-3336752af06126552ac4e15f104099213db2cc26b38e0f60321ad986c1ccc2be.jpg",
  "jean_class-69ddd003282e3d8232f9604a7ab403bc4673dce8a9f29e857e2eaf654c4ed93f.jpg",
  "students_smile-8003a14c51c30d6b35129f02343f83ea2000caf6a96b50bf9efc8c40d69c4f30.jpg",
  "student_dance-30a0ac523d621866546759da795a99cbbdc79a2fc7b53b773ec62eb96637891b.jpg",
  "jean_speaking-35a09dd3ba4f8b3d1ebd05a6f9bb6a03e2943c4189f53f44a82ae7425133d71d.jpg",
  "herbert_and_graduates-321fdb1767e8ecb70157b5b0d231dbfd3a9218bd00c1ccbcd7cad0f3c19790d6.jpg",
  "diploma_ladies-74df569697a19996c0df42cebcb4d2d31d5d85d95d4b286604e90b38e07bca5c.jpg",
  "lady_grads-b59b3764953fe5e259b905c98a989d397349ef4f1a9dfedced6d7379817e3a61.jpg",
  "diplomas-46346620e53d0449d24a2a6bbb61830a8a9fd416c85b825749e34bf67a01904f.jpg",
  "student_board-b9c9fdaffa568c1a424c7c51d5ad6d79215cb644be000716d4f2ee2f8eb4fce7.jpg",
  "lunch_icdh-2664bc0b7dc77c3cf4de2b15fb15fe35a6ccf89bf8ea14dcbc0e0726acc61ec7.jpg",
  "assembly-036a7316e3e3319b032366a86b7c689a8818b67a479b02abe65ae195df45ee15.jpg",
  "icdh_seated-fa285dd3e93733b34024e6c8252df5136fccaf6eea58f294769d3545c4699e89.jpg",
  "classroom_kids-7a570dd476afaeac3bc7849f3e968a37a8c968a8643a5161729da00a2953fc19.jpg",
  "student_group-f0e29e23422114575e57e35b833fae2117f47046f25fa9e12d19268e3f903b07.jpg",
  "culinary-2dcbd13b7b49b97fc254c5bab8d9077cfeedfbfdf466829e3604d4d3850b7267.jpg",
  "culinary2-68a52dab1a0c9a06a5f08b9b3e44b46de47c0cb0748e894e7f6a44eb4c05af46.jpg",
  "culinary3-99424a7cb0a7db0ebfb97daf0f2ca53feaa5b7d128e2d9164e02f2696a278f37.jpg",
  "culinary4-7216fae316a847342a254e1ff981bdcf39388ef68b24540762e81be791b91174.jpg",
  "culinary6-f1a6beb9a86da7697ece1078b1a2e72d342bd68cfba73239869459ec55eeb7c1.jpg",
].map((f) => BASE + f);
